// Composables
import { createRouter, createWebHistory } from 'vue-router'

export default app => {
	const setupRoutes = () => {
		return [
			{
				path: '/:showId?',
				name: 'Peep Show',
				component: () => import('@/views/PeepShow.vue')
			},
            {
				path: '/show/:id',
				name: 'Show Peep Show',
				component: () => import('@/views/ShowPeep.vue')
			},
            {
				path: '/upload',
				name: 'Upload Peep Show',
				component: () => import('@/views/UploadTool.vue')
			},
            {
				path: '/import/account/:userId/:code',
				name: 'Import Account',
				component: () => import('@/views/ImportAccount.vue')
			},
			{
				path: '/:catchAll(.*)',
				name: 'catchall',
				component: () => import('@/views/PeepShow.vue'),
			},
		]
	}
	const router = createRouter({
		history: createWebHistory(process.env.BASE_URL),
		routes: setupRoutes(),
		scrollBehavior(to, from, savedPosition) {
			// If the navigation is triggered to the same route (same path)
			if (to.path === from.path) {
				return { x: 0, y: 0 } // Scroll to the top
			}

			// If there is a savedPosition (back/forward navigation), restore the scroll position
			if (savedPosition) {
				return savedPosition
			}

			// For normal navigation between different routes, don't scroll to the top
			return { top: 0, left: 0 }
		},
	})

	app.use(router)
}
